<template>
  <div class="map-editor-mode">
    <r-text type="caption" style="margin-bottom: 4px;">
      Выбор режима
    </r-text>
    <div class="map-editor-mode__buttons">
      <r-radio-group
        :button-list="modes"
        :active="mode"
        @change="toggleEditorMode"
      />
    </div>
    <div
      class="map-editor-mode__attributes"
      v-if="editorState.mode === 'create'"
    >
      <el-checkbox class="r-checkbox" v-model="editorState.withAttributes">
        С указанием атрибутов
      </el-checkbox>
    </div>
  </div>
</template>

<script>
const modes = [
  { id: "create", label: "Создание" },
  { id: "edit", label: "Редактирование" }
];

export default {
  props: ["editor-state"],
  data() {
    return {
      modes
    };
  },
  computed: {
    mode() {
      return this.editorState.mode;
    }
  },
  methods: {
    toggleEditorMode(mode) {
      this.$emit("toggle-editor-mode", mode);
    }
  }
};
</script>

<style lang="scss">
.map-editor-mode {
  margin-bottom: 16px;

  &__attributes {
    margin-top: 8px;

    .el-checkbox__label {
      color: rgba(var(--white_white), 0.6);
      font-size: 12px;
    }
  }
}
</style>
